;; The component that slides up from bottom of the screen. Kind of like popup.
(ns livefeed.slideup
  (:require
   [reagent.core :as r]))

(defn component [_ _ focused-element-id _]
  ;; Mounting and unmounting flow:
  ;;  - When opening: Make visible first, then animate in
  ;;  - When closing: Animate out first, then make invisible
  (let [visible? (r/atom false)
        maximized? (r/atom false)
        on-transition-end (fn [e]
                            (when (= (.-target e) (.-currentTarget e))
                              (when @maximized?
                                ;; set focus
                                (some-> focused-element-id
                                        js/document.getElementById
                                        .focus))
                              (when-not @maximized?
                                (reset! visible? false))))]
    (fn [open? on-close _ children]
      (when open? (reset! visible? true))
      (when (and open? (not @maximized?))
        (js/setTimeout #(reset! maximized? true) 16)) ;; 16ms ~= 1 frame of 60fps
      (when (and (not open?) @maximized?)
        (reset! maximized? false))
      (when @visible?
        [:div.yle-livefeed__slideup__overlay
         {:class [(when @maximized?
                    "yle-livefeed__slideup__overlay--maximized")]
          :on-click (fn [e] (when (= (.-target e) (.-currentTarget e))
                              (on-close)))}
         [:div.yle-livefeed__slideup
          {:id "cw-slideup"
           :role "dialog"
           :aria-modal true
           :class [(when @maximized?
                     "yle-livefeed__slideup--maximized")]
           :on-transition-end on-transition-end}
          children]]))))
